import * as React from 'react';
import Button from '../../../../../common/components/Button';
import {GLOBAL, LOAN_APPLICATION_MX} from '../../../../constants/LabelConstants';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import {BureauQueryErrorProps} from '../../../../types/mx/creditoReal/components';

class BureauQueryErrorView extends React.Component<BureauQueryErrorProps, {}> {

    render() {
        return (
            <React.Fragment>
                <div className="modal-info">
                    <div className="modal-scroll">
                        <div className="container">
                            <div className="row d-flex justify-content-center mb-5 mt-3">
                                <img src={AssetsManager('/assets/images/common/warning-icon.svg')}
                                     width="64" height="58"/>
                            </div>
                            <div className="row p-none d-flex justify-content-center mb-3">
                                <h3 className="text-raleway text-secondary-lighten-1">
                                    {LOAN_APPLICATION_MX.NIP_QUERY_ERROR}
                                </h3>
                            </div>
                            <div className="row p-none d-flex justify-content-left pb-4 border-bottom">
                                <p className="regular-text">{LOAN_APPLICATION_MX.NIP_QUERY_ERROR_MESSAGE}</p>
                                <p className="regular-text">{LOAN_APPLICATION_MX.NIP_QUERY_ERROR_INPUT_DATA}</p>
                            </div>
                            <div className="row mt-4">
                                <div className="col-12 d-flex justify-content-center">
                                    <Button text={GLOBAL.CONTINUE} onPress={this.props.onPressNext}
                                            customClass="px-md-5" type={'outlined'}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default BureauQueryErrorView;